// FILECONTENT_START src/common/components/Card/Card.tsx
import { Paper, PaperProps } from "@mui/material";

export interface CardProps extends PaperProps {}

export default function Card({ children, sx, ...rest }: CardProps) {
  return (
    <Paper sx={{ padding: 2, ...sx }} {...rest}>
      {children}
    </Paper>
  );
}

// FILECONTENT_END src/common/components/Card/Card.tsx